import withReactContent from "sweetalert2-react-content";
import { turncate } from ".";
import { FileSizes } from "../statics/file-sizes";
import Swal from "sweetalert2";
import { alertToastConfig } from "../statics/alert-config";

export const validateFiles = async (files: any[], acceptFileTypes: string) => {
  const filteredFilesList: any = [];
  const errorsMsg: any[] = [];
  for (const file of files) {
    const { fileType, maxSize } = getFileInfo(file.type);
    const fileName = file.name.split("." + fileType)[0];
    if (!acceptFileTypes.includes(fileType)) {
      errorsMsg.push(
        `<div class='alert-file-name'>${turncate(
          fileName,
          20
        )}</div> is not allwed.`
      );
    } else if (file.size > maxSize) {
      errorsMsg.push(
        `<div class='alert-file-name'>${turncate(
          fileName,
          20
        )}</div> is bigger than max ${fileType.toUpperCase()} file size (${
          maxSize / 1024 / 1000
        } MB)`
      );
    } else {
      const newFile: any = new File(
        [file],
        file.name.replace(/[&/\\#, +()$~%'":*?<>{}]/g, "-"),
        { type: file.type }
      );
      if (fileType.includes("pdf")) {
        filteredFilesList.push(newFile);
      } else if (fileType.includes("jpg") || fileType.includes("png")) {
        newFile.src = await getImagePreview(newFile);
        filteredFilesList.push(newFile);
      } else {
        filteredFilesList.push(newFile);
      }
    }
  }
  showAlertMsg(errorsMsg);
  const submittedFiles = [...filteredFilesList];
  if (submittedFiles.length) {
    return submittedFiles;
  } else {
    return [];
  }
};

const showAlertMsg = async (queues: any[]) => {
  const MySwal = withReactContent(Swal);
  for (const message of queues) {
    await MySwal.fire({
      icon: "error",
      title: message,
      ...alertToastConfig,
    });
  }
};

export const getFileInfo = (type: string): any => {
  switch (type) {
    case "video/mp4":
      return { fileType: "mp4", maxSize: FileSizes.mp4.maxSize };
    case "image/jpeg":
      return { fileType: "jpg", maxSize: FileSizes.jpg.maxSize };
    case "image/png":
      return { fileType: "png", maxSize: FileSizes.png.maxSize };
    case "application/pdf":
      return { fileType: "pdf", maxSize: FileSizes.pdf.maxSize };
    default:
      return { fileType: "", maxSize: 1 };
  }
};

const getImagePreview = async (file: File) => {
  return new Promise<any>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const src = reader.result;
      resolve(src);
    };
    reader.readAsDataURL(file);
  });
};
